module.exports = __webpack_public_path__ + "media/insights-to-entrepreneurship-2.jpg";